import { GNS } from './GNS.js';

/**
 * GNS.ClassFactory
 * 
 * カスタムクラスを作成するためのファクトリーシステム
 * 
 * 機能:
 * - クラスの継承
 * - メソッドの自動バインディング
 * - 静的メソッドのサポート
 * 
 * 使用例:
 * var MyClass = GNS.create(ParentClass);
 * MyClass.init = function() { ... };
 */
GNS.ClassFactory = function () { };

/**
 * GNS.ClassFactory.create(ParentClass)
 * 
 * 新しいクラスを作成
 * 
 * @param {Object} ParentClass - 親クラス（オプション）
 * @returns {Object} - 新しいクラスのプロトタイプ
 */
GNS.ClassFactory.create = function (a) {
    var b = function () {
        for (var a in b.prototype._bind) "function" == typeof b.prototype._bind[a] && (this[a] = b.prototype._bind[a]
            .bind(this));
        b.prototype.init.apply(this, arguments)
    };
    if (a) {
        var c = function () { };
        c.prototype = a.prototype, b.prototype = new c, b.prototype._bind = {};
        for (var d in a.prototype._bind) "function" == typeof a.prototype._bind[d] && (b.prototype._bind[d] = a.prototype
            ._bind[d]);
        b.prototype._super = a.prototype
    }
    return b.prototype.init = function () { }, b.prototype._bind = b.prototype._bind || {}, b.prototype._static = b
        .prototype._self = b, b.prototype
};

// ショートカットエイリアス
GNS.create = GNS.ClassFactory.create;
